<template>
  <v-container key="selectedProductContainer" class="pt-8 ml-0 px-0" v-if="hasSelectedProduct">
    <v-row no-gutters class="customGutters">
      <v-col cols="auto">
        <selected-product-card :product="selectedProduct" />
      </v-col>
      <v-col class="py-0 pl-4">
        <!-- Accessories -->
        <v-container v-if="hasAccessories" class="ml-0 pa-0">
          <v-card width="906" color="#E9E5EE" class="elevation-0 pa-3 accessoriesCard" rounded="xl" outlined>
            <v-card-text class="sigfloH5 black--text pa-0 ml-1 mb-2">Accessories</v-card-text>
            <v-card-text class="pa-0">
              <v-row no-gutters class="customGutters">
                <v-col
                  cols="auto"
                  class="ma-1 pa-0 customGutters"
                  v-for="(accessory, index) in selectedProduct.productAccessoryModels"
                  :key="index"
                >
                  <accessory-card
                    :productId="selectedProduct.id"
                    :parentQuantity="selectedProduct.quantity"
                    :accessory="accessory"
                    :index="index"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex';
  import accessoryCard from '@/components/configurator/subsystem/AccessoryCard';
  import selectedProductCard from '@/components/configurator/subsystem/SelectedProductCard';

  export default {
    components: {
      accessoryCard,
      selectedProductCard
    },
    computed: {
      ...mapState(['configurator'])
    }
  };
</script>

<style scoped>
  .systemContainer {
    min-height: 650px;
  }
  .customGutters > .v-col:not(:last-child) {
    padding-right: 6px;
  }
  .accessoriesCard {
    border: 1px solid #ccc !important;
  }
</style>
